:host {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.cms-badge-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-size: 100%, 100%;
  color: var(--cms-semanticColors-primary-textOnBackground);
  font-family: 'TradeGothic';
  z-index: 10;
}

.badge-name {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.bg-badge {
  height: 24px;
  position: relative;
}

.badge-left {
  left: -3px;
}

.badge-right {
  background-position-x: right;
  right: -3px;
}
